import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(form.email, form.password);
    setLoading(false);
    if (!res.ok) {
      setError(res.error);
      toast.error(res.error);
      return;
    }
    toast.success(`Bienvenue ${res.user.firstName}`);
    nav(res.user.role === "admin" ? "/admin" : "/dashboard");
  };

  return (
    <div className="min-h-[calc(100vh-80px)] flex items-center justify-center px-6 py-16" data-testid="login-page">
      <div className="w-full max-w-md glass p-10 fade-up">
        <div className="label-eyebrow mb-3">Espace membre</div>
        <h1 className="font-display text-4xl mb-2">Connexion</h1>
        <p className="text-[#a3a8a4] text-sm mb-10">Accédez à votre tableau de fidélité.</p>

        <form onSubmit={submit} className="space-y-5" data-testid="login-form">
          <Field label="Email" type="email" value={form.email} onChange={(v)=>setForm({...form, email:v})} testid="login-email"/>
          <Field label="Mot de passe" type="password" value={form.password} onChange={(v)=>setForm({...form, password:v})} testid="login-password"/>

          {error && <div className="text-red-400 text-sm" data-testid="login-error">{error}</div>}

          <button disabled={loading} type="submit" className="w-full bg-[#d4af37] text-black px-6 py-3.5 font-medium tracking-widest uppercase text-xs hover:bg-[#e6c27a] transition-colors disabled:opacity-50" data-testid="login-submit">
            {loading ? "Connexion..." : "Se connecter"}
          </button>
        </form>

        <div className="mt-8 pt-6 border-t border-[rgba(253,251,247,0.08)] text-sm text-[#a3a8a4]">
          Pas encore de compte ? <Link to="/register" className="gold-text hover:underline" data-testid="goto-register">Créer un compte</Link>
        </div>
      </div>
    </div>
  );
}

function Field({ label, type, value, onChange, testid }) {
  return (
    <label className="block">
      <span className="label-eyebrow block mb-2">{label}</span>
      <input
        type={type}
        value={value}
        onChange={(e)=>onChange(e.target.value)}
        required
        data-testid={testid}
        className="w-full bg-[#0a0e0b] border border-[rgba(253,251,247,0.1)] px-4 py-3 text-[#fdfbf7] focus:border-[#d4af37] focus:outline-none transition-colors"
      />
    </label>
  );
}
